export const EVENT_SHADER_CAROUSEL_INITIALIZED = 'shaderCarousel:initialized';
export const EVENT_SHADER_CAROUSEL_READY       = 'shaderCarousel:ready';
export const EVENT_SHADER_CAROUSEL_ERROR       = 'shaderCarousel:error';